<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                element="InertiaLink"
                :pages="[
                    {
                        name: student.full_name,
                        href: meta.links.student_show,
                    },
                    {
                        name: $t('messages.attendance_review'),
                        href: null,
                    },
                ]"
            />
        </template>

        <form method="GET" action="" @submit.prevent="filter">
            <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-12">
                <div class="sm:col-span-2">
                    <div class="mt-1">
                        <FormLabel :value="$t('messages.date_from')" for="date_from" />
                        <FormInput id="date_from" v-model="form.date_from" type="date" name="date_from" class="mt-1" />
                        <FormError :value="form.errors.date_from" class="mt-2" />
                    </div>
                </div>
                <div class="sm:col-span-2">
                    <div class="mt-1">
                        <FormLabel :value="$t('messages.date_to')" for="date_to" />
                        <FormInput id="date_to" v-model="form.date_to" type="date" name="date_to" class="mt-1" />
                        <FormError :value="form.errors.date_to" class="mt-2" />
                    </div>
                </div>

                <div class="sm:col-span-8 align-bottom">
                    <label class="block text-sm font-medium leading-5 text-gray-700 mt-1"> &nbsp; </label>
                    <div class="mt-1">
                        <SubmitFormButton
                            :button-text="$t('messages.filter')"
                            :processing="form.processing"
                            is-filter
                        />
                    </div>
                </div>
            </div>
        </form>

        <div v-if="attendances.data.length === 0">
            <EmptyState picture />
        </div>
        <form @submit.prevent="submit" v-else>
            <div class="flex flex-col mt-5">
                <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
                    <div
                        class="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200"
                    >
                        <table class="min-w-full divide-y divide-gray-200">
                            <thead>
                                <tr>
                                    <th
                                        class="px-1 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                    ></th>
                                    <th
                                        class="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                    >
                                        {{ $t('messages.date') }}
                                    </th>
                                    <th
                                        class="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                    >
                                        {{ $t('messages.turn') }}
                                    </th>
                                    <th
                                        class="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                    >
                                        {{ $t('messages.absent') }}
                                    </th>
                                    <th
                                        class="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                    >
                                        {{ $t('messages.actions') }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="(attendance, index) in attendances.data"
                                    :key="attendance.id"
                                    :class="index % 2 === 0 ? 'bg-white' : 'bg-gray-50'"
                                >
                                    <td class="px-1 py-4 whitespace-nowrap text-sm leading-5 font-medium text-gray-900">
                                        <div class="flex justify-center">
                                            <label v-if="attendance.absent === true">
                                                <input
                                                    name="attendance_ids[]"
                                                    type="checkbox"
                                                    :value="attendance.id"
                                                    v-model="justifyForm.attendance_ids"
                                                    class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                                                />
                                            </label>
                                        </div>
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 font-medium text-gray-900">
                                        {{ attendance.date_display }}
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500">
                                        {{ attendance.turn_display }}
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500">
                                        <div class="flex items-center space-x-3 lg:pl-2">
                                            <div v-if="attendance.absent">
                                                <div v-if="attendance.is_justified">
                                                    <div class="shrink-0 w-2.5 h-2.5 rounded-full bg-green-400"></div>
                                                </div>
                                                <div v-else>
                                                    <div class="shrink-0 w-2.5 h-2.5 rounded-full bg-red-400"></div>
                                                </div>
                                            </div>
                                            <span>{{ attendance.justification }}</span>
                                        </div>
                                    </td>
                                    <td
                                        class="px-6 py-4 whitespace-nowrap text-right text-sm leading-5 font-medium flex gap-x-2 justify-end"
                                    >
                                        <InertiaSquareLinkButton action="show" :href="attendance.links.show" />
                                        <InertiaSquareLinkButton
                                            action="edit"
                                            :href="attendance.links.edit"
                                            v-if="attendance.can.edit"
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <div v-auto-animate>
                <div class="mt-3 flex gap-x-2" v-if="justifyForm.attendance_ids.length > 0">
                    <div>
                        <FormSelect required :options="options.justifications" v-model="justifyForm.justification" />
                    </div>
                    <div>
                        <SubmitFormButton
                            class="mt-1"
                            :button-text="$t('messages.justify')"
                            :processing="justifyForm.processing"
                        />
                    </div>
                </div>
            </div>
        </form>

        <template v-slot:pagination>
            <InertiaPagination :paginator="attendances" />
        </template>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import EmptyState from '@/components/EmptyState.vue';
import InertiaSquareLinkButton from '@/components/InertiaSquareLinkButton.vue';
import InertiaPagination from '@/Shared/InertiaPagination.vue';
import FormError from '@/components/Forms/FormError.vue';
import SubmitFormButton from '@/Pages/Teacher/Activities/Subactivities/SubmitFormButton.vue';
import FormInput from '@/components/Forms/FormInput.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import FormSelect from '@/components/Forms/FormSelect.vue';

export default {
    components: {
        FormSelect,
        FormLabel,
        FormInput,
        SubmitFormButton,
        FormError,
        InertiaPagination,
        InertiaSquareLinkButton,
        PanelPage,
        EmptyState,
    },
    layout: Layout,
    name: 'Show',
    props: ['meta', 'student', 'filters', 'options', 'attendances'],
    data() {
        return {
            justifyForm: this.$inertia.form({
                attendance_ids: [],
                student_id: this.student.id,
                justification: null,
            }),
            form: this.$inertia.form({
                date_from: this.filters.date_from,
                date_to: this.filters.date_to,
            }),
        };
    },
    methods: {
        submit() {
            this.justifyForm.patch(this.meta.links.justify);
        },
        filter() {
            this.form.get(this.meta.links.index);
        },
    },
};
</script>
